import React, { useEffect, useState, useCallback } from "react";
import { fetchAllInstagram, getJob } from "../../lib/api";
import { Button } from "../ui/button";
import { Instagram } from "lucide-react";
import { toast } from "sonner";

const isRunning = (job) => job && job.status !== "finished";

export function useBulkIgJob(onFinished) {
  const [job, setJob] = useState(null);

  useEffect(() => {
    if (!isRunning(job)) return undefined;
    const timer = setInterval(async () => {
      try {
        const j = await getJob(job.id);
        setJob(j);
        if (j.status === "finished") {
          toast.success(`Instagram aggiornato: ${j.ok} ok, ${j.failed} falliti`);
          onFinished();
        }
      } catch (e) {
        console.warn("bulk IG job poll failed", e);
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [job, onFinished]);

  const start = useCallback(async () => {
    try {
      const j = await fetchAllInstagram();
      setJob(j);
      toast.info(`Aggiornamento Instagram avviato per ${j.total} prospect`);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Aggiornamento Instagram fallito");
    }
  }, []);

  return { job, start, clear: () => setJob(null) };
}

export const BulkIgButton = ({ job, onStart }) => (
  <Button variant="outline" onClick={onStart} disabled={isRunning(job)} data-testid="fetch-all-ig-btn">
    <Instagram className={`mr-2 h-4 w-4 ${isRunning(job) ? "animate-pulse" : ""}`} />
    {isRunning(job) ? `Instagram ${job.done}/${job.total}` : "Aggiorna tutti da Instagram"}
  </Button>
);

export const BulkIgErrors = ({ job, onClose }) => {
  if (job?.status !== "finished" || !job.errors?.length) return null;
  return (
    <div className="rounded-xl border border-yellow-500/30 bg-yellow-500/5 p-3 text-xs" data-testid="bulk-errors">
      <div className="mb-1 font-semibold text-yellow-500">Aggiornamento Instagram: {job.ok} aggiornati, {job.failed} falliti</div>
      <ul className="space-y-0.5 text-muted-foreground">
        {job.errors.slice(0, 8).map((e) => (
          <li key={`${e.azienda}-${e.instagram}-${e.error}`}>{e.azienda} {e.instagram && `(@${e.instagram.replace("@", "")})`} — {e.error}</li>
        ))}
      </ul>
      <button className="mt-1 text-primary underline" onClick={onClose} data-testid="bulk-errors-close">Chiudi</button>
    </div>
  );
};
